export type PickerOption = {
  id: string;
  name: string;
};

export const propertyTypes: Array<PickerOption> = [
  { id: 'house', name: 'House' },
  { id: 'apartment', name: 'Apartment / unit' },
  { id: 'townhouse', name: 'Townhouse' },
  { id: 'villa', name: 'Villa' },
  { id: 'rural', name: 'Rural / acreage' },
  { id: 'other', name: 'Other' },
];

export const sellingReasons: Array<PickerOption> = [
  { id: 'curious', name: "Just curious what it's worth" },
  { id: 'selling-soon', name: 'Planning to sell in the next 3 months' },
  { id: 'selling-later', name: 'Planning to sell in 3–12 months' },
  { id: 'refinancing', name: 'Refinancing' },
  { id: 'other', name: 'Other' },
];

export type AppraisalType = 'in-person' | 'desktop';

export const appraisalTypes: Array<{ id: AppraisalType; name: string; description: string }> = [
  {
    id: 'in-person',
    name: 'In-person appraisal',
    description: 'An agent visits the property and gives you a detailed, walk-through appraisal.',
  },
  {
    id: 'desktop',
    name: 'Desktop estimate',
    description: 'A quicker, sight-unseen estimate based on the details you provide and recent local sales.',
  },
];

export const timeframes: Array<PickerOption> = [
  { id: 'asap', name: 'As soon as possible' },
  { id: '1-3-months', name: '1–3 months' },
  { id: '3-6-months', name: '3–6 months' },
  { id: '6-12-months', name: '6–12 months' },
  { id: 'not-sure', name: 'Not sure yet' },
];

export const contactMethods: Array<PickerOption> = [
  { id: 'phone', name: 'Phone call' },
  { id: 'email', name: 'Email' },
  { id: 'text', name: 'Text message' },
];

export const contactTimes: Array<PickerOption> = [
  { id: 'morning', name: 'Morning' },
  { id: 'afternoon', name: 'Afternoon' },
  { id: 'evening', name: 'Evening' },
  { id: 'anytime', name: 'Anytime' },
];

export type WizardStep = {
  id: 'property' | 'details' | 'timeline' | 'more-info' | 'contact' | 'review';
  title: string;
  shortTitle: string;
};

export const wizardSteps: Array<WizardStep> = [
  { id: 'property', title: 'Your property', shortTitle: 'Property' },
  { id: 'details', title: 'Property details', shortTitle: 'Details' },
  { id: 'timeline', title: 'Reason & timeline', shortTitle: 'Timeline' },
  { id: 'more-info', title: 'Tell us more', shortTitle: 'More info' },
  { id: 'contact', title: 'Your details', shortTitle: 'Contact' },
  { id: 'review', title: 'Review & submit', shortTitle: 'Review' },
];

export const APPRAISAL_DISCLAIMER: Array<string> = [
  "This is an estimate based on the details you provide — a licensed agent will confirm everything before any figure is finalised.",
  "We'll never share your details with anyone outside our agency.",
];
